/* eslint-disable no-underscore-dangle */

class MapSizeControl {
  /**
   * @param {Func} toggleCallback Called when the button is clicked.
   * @param {Boolean} clicked Initial state of the button.
   */
  constructor(toggleCallback, clicked = false) {
    this._toggleCallback = toggleCallback;
    this._clicked = clicked;
  }

  onAdd(map) {
    this._map = map;
    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-ctrl hidden-md-down';

    this._button = document.createElement('button');
    this._button.classList.add('map-control', 'map-control--expand-collapse');
    this._button.innerText = this._clicked ? 'Smaller map' : 'Larger map';

    this._button.addEventListener('click', (event) => {
      this._clicked = !this._clicked;
      this._button.innerText = this._clicked ? 'Smaller map' : 'Larger map';
      this._toggleCallback(event, this._map);
    });

    this._container.appendChild(this._button);

    return this._container;
  }

  onRemove() {
    this._button.removeEventListener('click', this._toggleCallback);
    this._container.parentNode.removeChild(this._container);
    this._map = undefined;
  }
}

export default MapSizeControl;
